import styled, { css } from 'styled-components';
import { media } from 'components/styles';

const Box = styled.div`
	text-align: center;
	padding: 1.6rem 0 2rem 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: linear-gradient(
		to top,
		${({ theme }) => theme.payment.paymentOptions.box.color1} 18%,
		${({ theme }) => theme.payment.paymentOptions.box.color2} 112%
	);
	${media.min.medium(css`
		padding: 2.4rem 0 2.8rem 0;
	`)};
`;

const Name = styled.p`
	font-size: 2rem;
	color: ${({ theme }) => theme.white};
	font-weight: ${({ theme }) => theme.font.medium};
	letter-spacing: 0.6px;
	line-height: 1.2;
	${media.min.medium(css`
		font-size: 2.4rem;
	`)};
`;

const Info = styled.p`
	font-size: 1.2rem;
	color: ${({ theme }) => theme.payment.paymentOptions.info.color};
	font-weight: ${({ theme }) => theme.payment.paymentOptions.info.fontWeight};
	margin-bottom: 1.5rem;
	${media.min.medium(css`
		font-size: 1.4rem;
		margin-bottom: 2rem;
	`)};
`;

const Price = styled.span`
	font-size: 2rem;
	color: ${({ theme }) => theme.white};
	font-weight: ${({ theme }) => theme.font.normal};
	opacity: 0.7;
	${media.min.medium(css`
		font-size: 2.4rem;
	`)};
`;

export { Box, Name, Info, Price };
